import React, { useState } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useHistory, useParams } from 'react-router-dom'

const DuplicateTask = ({ readOnly, task, refetch }) => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const { orderId, jobId, versionId } = useParams()
  const [loading, setLoading] = useState(false)

  const disabled = readOnly || loading

  const onClick = () => {
    if (disabled || !confirm(formatMessage(messages.confirmPrompt))) {
      return
    }

    setLoading(true)

    fetch(`/rest/v2/task/${task.uid}/duplicate`, { method: 'POST' })
      .then((response) => response.json())
      .then(({ success, data, errors }) => {
        setLoading(false)

        if (!success) {
          toastr.error(Object.values(errors).join(', '))
          return
        }

        toastr.success(formatMessage(messages.success))
        refetch()
        history.push(`/orders/${orderId}/jobs/${jobId}/versions/${versionId}/tasks/${data.uid}`)
      })
      .catch((error) => {
        setLoading(false)
        toastr.error(error)
      })
  }

  return (
    <Menu.Item key='duplicate' disabled={disabled}>
      {(props) => (
        <MenuButton disabled={disabled} {...props} onClick={onClick}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default DuplicateTask
